<template>
  <div class="content">
    <div class="content-wrap">
      <div class="col-lg-12">
        <PageTitle class="page-title">Інформація про страхового посередника</PageTitle>
      </div>
      <div class="col-lg-12">
        <sub-agent-info />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SubAgentInfo from '../../views/sub-agent';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import {
  UkaskoBigLogo
} from '@/shared/ui/promo';
import EmptyLayout from "@/layouts/emptyLayout";

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { EmptyLayout, PageLayout, PageTitle, SubAgentInfo, UkaskoBigLogo },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.content-wrap {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}

@media (max-width: 1220px) and (min-width: 992px) {
  ::v-deep .list-propositions .tabs-block {
    max-width: none;
    width: 100%;
  }
}
</style>
